export default {
    setTotemsArray(state,t){
        state.totemsArray = t
    },
    resetTotems(state,t){
        state.totemsArray = []
    },
}